module.exports = __webpack_public_path__ + "static/media/report_4.76eed9fb.png";